'use client';

import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';
import { configPublic } from '@src/config.public';
import { getBuilderPreviewMode } from './builder.util';
export const Osano = () => {
  const searchParams = useSearchParams();
  const edit = searchParams ? getBuilderPreviewMode(Object.fromEntries(searchParams.entries())).edit : false;
  const {
    isEnabled,
    configId,
    configVersion
  } = configPublic.osano;

  /* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
  // Prepare Osano to receive event listeners before it loads
  // window.Osano() can continue to be used after Osano CMP loads
  // See: https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api#-pre-load-and-windowosano
  useEffect(() => {
    function mockOsano(...args: any) {
      window.Osano.data.push(args);
    }
    window.Osano = window.Osano || mockOsano;
    window.Osano.data = window.Osano.data || [];
  }, []);
  /* eslint-enable @typescript-eslint/prefer-nullish-coalescing */

  if (edit || !isEnabled) return null;
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script id="osano-script" itemID="osano-script" strategy="beforeInteractive" src={`https://cmp.osano.com/AzZcuESCJWcN06dnY/${configId}/osano.js?v=${configVersion}`} />
  );
};